import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { ToastController, Platform, App, AlertController } from 'ionic-angular';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { DataProvider } from '../../providers/data/data';
import { WebsocketService } from '../../providers/websocket/websocket';
import { SimpleAlertProvider } from '../../providers/simple-alert/simple-alert';

@Injectable()
export class ServicesProvider {
    
    
    baseUrl = "http://www.jeuxpresto.com:80";
    wsUrl = "ws://www.jeuxpresto.com:80";
    headers;
    options;

	public messages: Subject<Object>;
	
	private _gameEventsSource = new Subject<Object>();
	gamesEvents = this._gameEventsSource.asObservable();

	toastTrophyShowed = false;
	toastTitle;
	toastMessage;
	toastLogo = "data:image/png;base64,";

	timeOutPingPong;
	intervalPingPong;

    constructor(public http: Http, public dataService: DataProvider, private wsService: WebsocketService, public simpleAlert: SimpleAlertProvider, private toastCtrl: ToastController, public appCtrl: App, public alertCtrl: AlertController) {
        this.headers = new Headers();
		let optionsArgs:RequestOptionsArgs = { withCredentials: true }
    	this.options = new RequestOptions(optionsArgs);
	
        //this.options = new RequestOptions({ headers: this.headers, withCredentials: true });
    }
    

    login(login, password): Observable<number>{
		
        
        let body = new FormData();
        body.append("pseudo", login);
        body.append("password", password);
    
        let url = this.baseUrl+"/service/login";

        return Observable.create(obs => {
        
            this.http.post(url, body, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
                    // login ok
                    if (data.result == 0){

                        this.dataService.playerId = data.playerId;
		
                        this.dataService.avatarId = data.payload.avatarId;
		
                        this.dataService.username = data.payload.pseudo;
                        this.dataService.name = data.payload.name;
                        this.dataService.firstname = data.payload.firstname;
                        this.dataService.password = password;
		
						this.dataService.totalExp = data.payload.exp.exp;
						this.dataService.level = data.payload.exp.level;
						
		
						

						if('cashType' in data.payload){
							this.dataService.cashType = data.payload.cashType;
						}
						else {
							this.dataService.cashType = "cash";
						}
						
						
		
						this.dataService.logged = true;

                        this.dataService.save();
		
						
						
						this.connexionTry()
						.subscribe(result => {
							if (result == 0){
								obs.next(0);
								obs.complete();
							}
							// erreur de connexion
							else {
								obs.next(result);
								obs.complete();
							}
						});
						
						
                    }
                    // identifiants pas ok
                    else {

                        obs.next(data.result);
                        obs.complete();
                    }

		
                },
                err => {
                    obs.next(-1);
                    obs.complete();
                }
            );
        });
    }
	
	connexionTry(): Observable<number>{
		return Observable.create(obs => {
			console.log("CONNEXION TRY")
			this.afterLoginOperations()
			.subscribe(result => {
		
				var success = true;
				
				result.forEach(elt => {
		
					if (elt != 0){
						console.log("ERREUR WS AFTER LOGIN");
						success = false;
						obs.next(elt);
						obs.complete();
					}
					else {
						console.log("ELT AFTER LOGIN OK")	
					}
				});
				
				if (success){
					console.log("RESULT CONNEXION TRY OK")
					// creation websocket
					this.messages = <Subject<Object>>this.wsService
					.connect(this.wsUrl, this.dataService.WSToken)
					.map((response: MessageEvent): Object => {
						let data = JSON.parse(response.data);
						return data;
					});


					// initialisation websocket
					this.messages.next({
						event:"init",
						accessToken:this.dataService.WSToken
					});

					this.intervalPingPong = setInterval(() =>{
						this.messages.next({event:"ping"});
						this.timeOutPingPong = setTimeout(() => {
							console.log("CONNEXION COUPEE");
							this.disconnexionHandling();
						}, 2000);
					}, 5000);

					// subscribe websocket
					this.messages.subscribe(
						msg => {		
							
							if (msg["event"] == "updatePurse"){
								this.dataService.treflouz = msg["params"].purses.token;
								this.dataService.euro = msg["params"].purses.EUR;
							}
							else if(msg["event"] == "updateExp"){
								let currentLevel = this.dataService.level;
								this.getPlayerInfo().subscribe(success => {

									if (success != 0){
										let alert = this.simpleAlert.createAlert('Echec', "Une erreur s'est produite");
										alert.present();
									}
									else {
										// notifs déblocage contenu
										var newLevel = this.dataService.level;

										if (newLevel > currentLevel){
											// fonctionnalites cash
											if (newLevel == this.dataService.getLockedElementLevel("cash")){

												this.dataService.notifShop = true;
												this.dataService.notifMachine = true;
											}
											// fonctionnalites chat
											if (newLevel == this.dataService.getLockedElementLevel("chat")){
												this.dataService.notifChat = true;
											}
											// jeux
											for (var i in this.dataService.games){
												for (var j in this.dataService.games[i].variants){
													if (this.dataService.games[i].variants[j].level == newLevel){
														this.dataService.games[i].variants[j].notif = true;

													}
												}

											}
										}
									}
								});


							}
							else if(msg["event"] == "newTrophy"){
								this.getTrophyList().subscribe(success => {

									if (success != 0){
										let alert = this.simpleAlert.createAlert('Echec', "Une erreur s'est produite");
										alert.present();
									}

								});

								this.toastTrophy(msg["params"].id);
							}
							else if(msg["event"] == "newGatcha"){
								this.getGatchasList().subscribe(success => {

									if (success != 0){
										let alert = this.simpleAlert.createAlert('Echec', "Une erreur s'est produite");
										alert.present();
									}
								});
							}
							else if(msg["ping"] == "pong"){
								clearTimeout(this.timeOutPingPong);
							}

							this._gameEventsSource.next(msg);

						}
					);


					obs.next(0);
					obs.complete();
				}
			},
			err => {
				console.log("ERROR CONNEXION TRY")
				obs.next(-1);
				obs.complete();
			});
		});
	}
	
	disconnexionHandling(){
		// couper l'interval de test
		clearInterval(this.intervalPingPong);
		
		// prévenir le jeu que la connexion est coupée
		this._gameEventsSource.next({event:'connection', connected:false});
		
		// fermer le websocket
		this.wsService.close();
		
		// relancer 3 tentatives de connexions
		var cptConnexion = 0;
		
		var intervalConnexion = setInterval(() => {
			console.log("TENTATIVE RECONNEXION NUMERO "+cptConnexion)
			if (cptConnexion <= 2){
				cptConnexion++;
				this.connexionTry()
				.subscribe(result => {
					
					// reconnexion ratée
					if (result != 0){
						console.log("RECONNEXION RATEE");
					}
					// connexion rétablie
					else {
						console.log("CONNEXION RETABLIE")
						clearInterval(intervalConnexion);
						// prévenir le jeu que la connexion est rétablie
						this._gameEventsSource.next({event:'connection', connected:true});
					}
				},
				err => {
					console.log("NO NO NO")
				});
			}
			else {
				clearInterval(intervalConnexion);
				
				console.log("3 TENTATIVES : AFFICHAGE POPUP");
				
				let alert = this.alertCtrl.create({
					title: 'La connexion internet a été perdue',
					message: 'Voulez-vous retenter de vous connecter ?',
					buttons: [
					  {
						text: "Non",
						handler: () => {
						  	this.reinitApp();
							this.appCtrl.getRootNav().setRoot("SplashPage");
						}
					  },
					  {
						text: "Oui",
						handler: () => {
						  	this.disconnexionHandling();
						}
					  }
					]
				  });
				  alert.present();
				
			}
		}, 3000);
		
		
		
	}
	
	toastTrophy(trophyId){
		var trophyIdTab = trophyId.split("_");
		var gameId = trophyIdTab[0]+"_"+trophyIdTab[1];
		var game = this.dataService.getGame(gameId);
		this.toastLogo = "data:image/png;base64,"+this.dataService.getTrophiesForGame(game).logo;
		var trophies = this.dataService.getTrophiesForGame(game).trophies;

		var trophy = trophies[trophyIdTab[2]];
		this.toastTitle = trophy.title;
		this.toastTitle = trophy.title;
		this.toastMessage = `Vous gagnez `+trophy.value.amount+` Treflouz`;
		
		this.toastTrophyShowed = true;
		setTimeout(() => {
			this.toastTrophyShowed = false;
		}, 3000);


	}
	
	signin(login, password, cash): Observable<number>{
        
        let body = new FormData();
        body.append("pseudo", login);
        body.append("password", password);
    
        let url = this.baseUrl+"/register";

        return Observable.create(obs => {
        
            this.http.post(url, body, this.options).timeout(3000)
            .map(res => res.json())
            .subscribe(
                data => {
                    // signin ok
                    if (data.result == 0){
						// si compte fun : ok
                        if (!cash){
							obs.next(0);
							obs.complete();
						}
						// si compte cash : on doit faire le switch
						else {
							this.switchCash(login)
							.subscribe(switched => {


								if (switched == 0){
									obs.next(0);
									obs.complete();
								}            

								else {
									obs.next(-1);
									obs.complete();    
								}
							});
						}
						
                    }
                    else {

                        obs.next(-1);
                        obs.complete();
                    }

		
                },
                err => {
                    obs.next(-1);
                    obs.complete();
                }
            );
        });
    }
	
	switchCash(login): Observable<number>{
        
        let body = new FormData();
        body.append("pseudo", login);
    
        let url = this.baseUrl+"/switchCash";

        return Observable.create(obs => {
        
            this.http.post(url, body, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
                    if (data.result == 0){
						obs.next(0);
						obs.complete();
                    }
                    else {
                        obs.next(-1);
                        obs.complete();
                    }
                },
                err => {
                    obs.next(-1);
                    obs.complete();
                }
            );
        });
    }
	
	switchCashLogged(): Observable<number>{
    
        let url = this.baseUrl+"/switchCash";

        return Observable.create(obs => {
        
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
                    if (data.result == 0){
		
						this.getPlayerInfo().subscribe(success => {

							if (success != 0){
								obs.next(-1);
                        		obs.complete();
							}
							else {
								obs.next(0);
								obs.complete();
							}
						});

						
                    }
                    else {
                        obs.next(-1);
                        obs.complete();
                    }
                },
                err => {
                    obs.next(-1);
                    obs.complete();
                }
            );
        });
    }
    
    logout(): Observable<number> {
        
        let url = this.baseUrl+"/service/logout";
        
        return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
		
					
        
                    this.reinitApp();

                    if (data.result == 0){

                        observer.next(0);
                        observer.complete();
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }


                },
                err => {
                    
                    this.reinitApp();
                    
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
        
    }
	
	getPlayerInfo(){
		
		let url = this.baseUrl+"/service/playerInfo";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
		
                        this.dataService.avatarId = data.player.avatarId;
		
                        this.dataService.username = data.player.pseudo;
                        this.dataService.name = data.player.name;
                        this.dataService.firstname = data.player.firstname;
		
						this.dataService.totalExp = data.player.exp.exp;
						this.dataService.level = data.player.exp.level;
						this.dataService.computeExp();
						

						if('cashType' in data.player){
							this.dataService.cashType = data.player.cashType;
						}
						else {
							this.dataService.cashType = "cash";
						}

		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}

	
	getServerTime(): Observable<number>{
        
        let url = this.baseUrl+"/service/serverTime";
		
		var t1 = Date.now();
        
        return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
					if (data.result == 0){
		
						var t3 = Date.now();
		
						var delta = parseInt(data.time) - (t1 + t3)/2.0;
		
                        this.dataService.deltaTime = delta;

		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
    }
	
	getPurse(): Observable<number>{
        
        let url = this.baseUrl+"/service/purse";
        
        return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
					if (data.result == 0){
		
						this.dataService.treflouz = data.purseList.token;
						this.dataService.euro = data.purseList.EUR;

			
		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
    }
	
	getWSToken(): Observable<number>{
        
        let url = this.baseUrl+"/service/token";
        
        return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
					if (data.result == 0){
		
						this.dataService.WSToken = data.accessToken;

		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
    }
	
	getAvailableGames(){
		
		let url = this.baseUrl+"/service/gameList";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
						
						for (var i in data.games){
							
							data.games[i].fullId = data.games[i]._id;
							
							data.games[i].logoLink = this.getGameLogo(data.games[i]._id);
							data.games[i].backgroundLink = this.getGameBackground(data.games[i]._id);
							data.games[i].titleLink = this.getGameTitle(data.games[i]._id);
							
							
        					for (var j in data.games[i].variants){
								data.games[i].variants[j].logoLink = this.getVariantLogo(data.games[i]._id, data.games[i].variants[j].id);
								data.games[i].variants[j].notif = false;
							}       
						}
		
						this.dataService.games = data.games;

		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}

	getTheMachine(){
		
		let url = this.baseUrl+"/service/machineData";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
		
						this.dataService.machine = data.games[0];

		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}

	getLevelList(){
		
		let url = this.baseUrl+"/gamification/levelList";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
						
		
						this.dataService.levelList = data.levels;
						this.dataService.computeExp();
						this.dataService.computeLockedElements();
		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}

	getTrophyList(){
		
		let url = this.baseUrl+"/gamification/trophy/fr-FR";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
						
						
						this.dataService.trophiesList = data.trophy;
						this.dataService.computeTrophies();
		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}

	getTreflouzPacks(){
		
		let url = this.baseUrl+"/service/treflouzPack";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
						
						this.dataService.treflouzPacks = data.data;
						this.dataService.computeTreflouzPacks();
		
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}

	getAvatarsList(){
		
		let url = this.baseUrl+"/gamification/avatar/list";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
						
						this.dataService.avatarsList = data.list;
						this.dataService.computeAvatars();
						
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}

	getGatchasList(){
		
		let url = this.baseUrl+"/gamification/gatcha/list";
		
		return Observable.create(observer => {
            this.http.get(url, this.options)
			.timeout(2000)
            .map(res => res.json())
			.subscribe(
                data => {
					if (data.result == 0){
						
						this.dataService.gatchasList = data.list;
						this.dataService.computeGatchas();
						
						observer.next(0);
						observer.complete();
						
                    }
                    else {

                        observer.next(data.result);
                        observer.complete();
                    }
                },
                err => {
                    observer.next(-1);
                    observer.complete();
                }
            );
        });
	}


	afterLoginOperations(): Observable<number[]>{
		
		let serverTimeObservable = Observable.create(observer => {
		
			this.getServerTime()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let purseObservable = Observable.create(observer => {
		
			this.getPurse()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let WSTokenObservable = Observable.create(observer => {
		
			this.getWSToken()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let gameListObservable = Observable.create(observer => {
		
			this.getAvailableGames()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let machineDataObservable = Observable.create(observer => {
		
			this.getTheMachine()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let levelListDataObservable = Observable.create(observer => {
		
			this.getLevelList()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let trophyListDataObservable = Observable.create(observer => {
		
			this.getTrophyList()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let treflouzPacksObservable = Observable.create(observer => {
		
			this.getTreflouzPacks()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let avartarsListObservable = Observable.create(observer => {
		
			this.getAvatarsList()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let gatchasListObservable = Observable.create(observer => {
		
			this.getGatchasList()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let playerInfosObservable = Observable.create(observer => {
		
			this.getPlayerInfo()
			.subscribe(result => {

				if (result == 0){
					observer.next(0);
					observer.complete();
				}

				else {
					observer.next(-1);
					observer.complete();
				}

			},
			err => {
				observer.next(-1);
				observer.complete();
			});
		});

		let observables = Array(
			serverTimeObservable, 
			purseObservable, 
			WSTokenObservable, 
			gameListObservable, 
			machineDataObservable, 
			levelListDataObservable,
			trophyListDataObservable,
			treflouzPacksObservable,
			avartarsListObservable,
			gatchasListObservable,
			playerInfosObservable);

		return Observable.forkJoin<number>(observables);

	}

	buyTreflouz(pack): Observable<number>{
        
        let body = new FormData();
        body.append("packId", pack._id);
    
        let url = this.baseUrl+"/service/buy";
		

        return Observable.create(observer => {
        
            this.http.post(url, body, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
					observer.next(data.result);
                    observer.complete();
                },
                err => {
					observer.next(-1);
                    observer.complete();
                }
            );
        });
    }
	
	setAvatar(avatarId): Observable<number>{
        
        let body = new FormData();
        body.append("avatarId", avatarId);
    
        let url = this.baseUrl+"/service/setAvatar";
		

        return Observable.create(observer => {
        
            this.http.post(url, body, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
					observer.next(data.result);
                    observer.complete();
                },
                err => {
					observer.next(-1);
                    observer.complete();
                }
            );
        });
    }
	
	openGatcha(gatcha): Observable<number>{
        
        let body = new FormData();
        body.append("gatchaId", gatcha.id);
    
        let url = this.baseUrl+"/gamification/gatcha/open";
		

        return Observable.create(observer => {
        
            this.http.post(url, body, this.options)
			.timeout(2000)
            .map(res => res.json())
            .subscribe(
                data => {
					if (data.result == 0){
						// ouverture de gatcha expiré
						if ("content" in data){
							this.dataService.contentGatcha = data.content;
		
							// augmenter compteur notif avatar si nouveau débloqué
							for (var i in data.content.fragments){
								if (!data.content.fragments[i].locked){
									this.dataService.notifAvatar++;
								}
							}
						}

						data.gatcha.id = gatcha.id;
						for (var i in this.dataService.gatchasListCleaned){
							if (this.dataService.gatchasListCleaned[i].id == gatcha.id){
								this.dataService.gatchasListCleaned[i] = data.gatcha;
							}
						}

						observer.next(0);
                    	observer.complete();
					}
					else {
						observer.next(data.result);
                    	observer.complete();
					}
					
                },
                err => {
					observer.next(-1);
                    observer.complete();
                }
            );
        });
    }
	
	launchGame(gameVersion, gameVariant){
        let url = this.baseUrl+"/game/applet/"+gameVersion+"/"+gameVariant+"?deltaTime="+this.dataService.deltaTime;
		
		return url;
	}	

	getGameLogo(gameVersion){
        let url = this.baseUrl+"/service/game/logo/"+gameVersion
		return url;
	}	

	getGameBackground(gameVersion){
        let url = this.baseUrl+"/service/game/background/"+gameVersion
		return url;
	}

	getGameTitle(gameVersion){
        let url = this.baseUrl+"/service/game/titleLogo/"+gameVersion
		return url;
	}

	getVariantLogo(gameVersion, gameVariant){
        let url = this.baseUrl+"/service/game/variant/"+gameVersion+"/"+gameVariant;
		return url;
	}

    reinitApp(){
		clearInterval(this.intervalPingPong);
		this.wsService.close();
        this.dataService.initData();
        this.dataService.save();
    }



}



// WEBPACK FOOTER //
// ./src/providers/services/services.ts